<template>
  <VTextField
    ref="input"
    v-currency="options"
    :value="formattedValue"
    outlined
    dense
    v-bind="$attrs"
    @change="onChange"
    @input="onInput"
    :hide-details="hideDetails"
  />
</template>

<script>
export default {
  name: 'VCurrencyField',
  props: {
    value: {
      type: Number,
      default: null
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {
          locale: 'id',
          currency: 'IDR',
          distractionFree: false,
          precision: 0
        };
      }
    }
  },
  data() {
    return {
      formattedValue: null
    };
  },
  watch: {
    value(value) {
      this.setValue(value);
    }
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    setValue(value) {
      this.$ci.setValue(this.$refs.input, value);
    },
    onInput(value) {
      this.$emit('input', this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    onChange(value) {
      this.$emit('change', this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    }
  }
};
</script>
